"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileTypeExceptAdmin = exports.UserProfileType = void 0;
var UserProfileType;
(function (UserProfileType) {
    UserProfileType["ApiKey"] = "api_key";
    UserProfileType["Admin"] = "admin";
    UserProfileType["Staff"] = "staff";
    UserProfileType["Student"] = "student";
    UserProfileType["Others"] = "others";
})(UserProfileType = exports.UserProfileType || (exports.UserProfileType = {}));
var UserProfileTypeExceptAdmin;
(function (UserProfileTypeExceptAdmin) {
    UserProfileTypeExceptAdmin["Staff"] = "staff";
    UserProfileTypeExceptAdmin["Student"] = "student";
    UserProfileTypeExceptAdmin["Others"] = "others";
})(UserProfileTypeExceptAdmin = exports.UserProfileTypeExceptAdmin || (exports.UserProfileTypeExceptAdmin = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlcy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2RhdGEvaW50ZXJmYWNlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFvREEsSUFBWSxlQU1YO0FBTkQsV0FBWSxlQUFlO0lBQ3ZCLHFDQUFrQixDQUFBO0lBQ2xCLGtDQUFlLENBQUE7SUFDZixrQ0FBZSxDQUFBO0lBQ2Ysc0NBQW1CLENBQUE7SUFDbkIsb0NBQWlCLENBQUE7QUFDckIsQ0FBQyxFQU5XLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBTTFCO0FBRUQsSUFBWSwwQkFJWDtBQUpELFdBQVksMEJBQTBCO0lBQ2xDLDZDQUFlLENBQUE7SUFDZixpREFBbUIsQ0FBQTtJQUNuQiwrQ0FBaUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsMEJBQTBCLEdBQTFCLGtDQUEwQixLQUExQixrQ0FBMEIsUUFJckMifQ==